export default __webpack_public_path__ + "static/media/announcement_4@2x.60ec4284.png";